import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

// Larguras explicitas (drawerWidthClosed nao expoe drawerWidthOpen no
// sidebarConfig publico; o sidebar aberto e' 224px no Backstage default).
const SIDEBAR_OPEN_WIDTH = 224;

const useSidebarLogoStyles = makeStyles({
  root: {
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: -14,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  linkClosed: {
    width: sidebarConfig.drawerWidthClosed,
  },
  linkOpen: {
    width: SIDEBAR_OPEN_WIDTH,
  },
});

// Home aponta para /create (Scaffolder) — nao ha pagina home no app
// IBICT; o ponto de entrada esperado e' criar projeto a partir de modelo.
export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link
        to="/create"
        underline="none"
        className={`${classes.link} ${isOpen ? classes.linkOpen : classes.linkClosed}`}
        aria-label="Início"
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
